// @ts-nocheck
import Divider from 'atoms/divider/divider';
import Heading from 'atoms/heading/heading';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React from 'react';
import { Button } from 'antd';

interface TProps {
	title: string;
}

const ModalHeader = (props: TProps) => {
	const { title } = props;
	return (
		<Stack isVertical gutter="small" className="common-modal-header">
			<StackItem isStretch className="p-0">
				<Heading>{title}</Heading>
			</StackItem>
			{/* <StackItem isStretch>
        <Divider />
      </StackItem> */}
			{/* <Button type="link" className='modal-close'><i className='icon-close' /></Button> */}
		</Stack>
	);
};

export default ModalHeader;
